module.exports = __webpack_public_path__ + "static/media/skiing-nordic.c542e993.svg";